import { render, staticRenderFns } from "./purpose-classification.vue?vue&type=template&id=1d1ca6f4"
import script from "./purpose-classification.vue?vue&type=script&lang=js"
export * from "./purpose-classification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports